import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { EnableFor } from '../../../../../containers/EnableForRole';
import { useClarificationsPermissions } from '../Clarifications.permissions';
import { IClarificationsStore } from '../Clarifications.store';
import { ClarifyModalContainer } from './ClarifyModal.container';

export const ClarifyButtonContainer = observer((): ReactElement => {
  const permissions = useClarificationsPermissions();
  const { clarification } = useInjection(IClarificationsStore.$);

  const { t } = useTranslator();
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleToggle = (): void => {
    setShowModal((prevState) => !prevState);
  };

  const showButton = clarification && !clarification.answer;

  return (
    <EnableFor
      hasPermission={permissions.canClarify()}
      hideWhenNoAccess
    >
      {showButton && <Button onClick={handleToggle}>{t('clarifications.answer_clarification_button')}</Button>}
      <ClarifyModalContainer
        showModal={showModal}
        onToggle={handleToggle}
      />
    </EnableFor>
  );
});
